import { render, staticRenderFns } from "./CreateUtilityTypeForm.vue?vue&type=template&id=b0255b52&scoped=true"
import script from "./CreateUtilityTypeForm.vue?vue&type=script&lang=js"
export * from "./CreateUtilityTypeForm.vue?vue&type=script&lang=js"
import style0 from "./CreateUtilityTypeForm.vue?vue&type=style&index=0&id=b0255b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0255b52",
  null
  
)

export default component.exports